import { NgModule } from '@angular/core';
import { SplashPageModule as SharedSplashPageModule } from '@huge-monorepo/shared/pages';

@NgModule({
  imports: [SharedSplashPageModule],
  exports: [SharedSplashPageModule],
})
export class SplashPageModule {}
